<template>
  <div>
    <b-modal :id="idModal" class="modal-noti" size="lg" hide-footer hide-header centered>
      <div class="modal-noti__head display-flex justify-content-between">
        <h3 class="primary-color-txt font-size-22 font-sanpro-semibold">Chi tiết thông báo</h3>
        <button
          @click="exitModal"
          type="button"
          class="btn-close secondary_text_color font-size-16 font-sanpro-semibold four-color border-0 bg-transparent"
        >
          <img src="@/assets/img/icon-close.png" class="icon-close" alt />
        </button>
      </div>
      <!-- {{getDataDetailNotifi}}xxxxxxxx -->
      <div class="modal-noti__body">
        <!-- <div class="item">
          <label class="item__label secondary-color-txt">Gửi từ:</label>
          <div class="item__val">{{ dataSource.name }}</div>
        </div>-->
        <div class="item">
          <label class="item__label secondary-color-txt">Tiêu đề:</label>
          <div class="item__val">{{ dataSource.title }}</div>
        </div>
        <div class="item">
          <div class="item__val">{{ dataSource.message }}</div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
// import { STORE_KEY } from '@/store/common/constants'
import { mapState } from "vuex";
import { MODAL_ID_REQ_INFO_DETAIL } from "@/store/common/constants";
import { apiNotificationSend } from "@/store/common/api";
import mixinsFiles from "../content-files/mixinsFiles";
import { getAuth } from "@/utils/jwt";
// import {
//   MODULE_ADMINISTRATOR,
//   MODULE_TEACHER,
//   MODULE_PUBLISHING,
//   MODULE_CTDMPP,
//   MODULE_TCBT,
//   MODULE_DEPARTMENT,
//   MODULE_SCHOOL,
//   EMAIL_PUBLIC,
//   MODULE_ROOM,
//   ID_MODAL_LOGIN,
// } from "@/store/auth/constants";
export default {
  name: "ModalNotiRequestEditInfo",
  mixins: [mixinsFiles],
  // props: {
  //   dataSource: Object,
  // },
  components: {},
  data() {
    return {
      dataSource: {},
      id: 0,
      name: this.$route.name,
      idModal: MODAL_ID_REQ_INFO_DETAIL,
      authInfo: {},
    };
  },
  computed: {
    ...mapState("common", ["getDataDetailNotifi"]),
  },
  mounted() {
    this.authInfo = getAuth();
  },
  watch: {
    $route: "handelRoute",
    getDataDetailNotifi(newVal) {
      if (newVal && newVal.notificationId > 0) {
        this.dataSource = newVal;
      }
    },
  },
  methods: {
    // handleCloseModal() {
    //   this.$bvModal.hide(MODAL_ID_REQ_INFO_DETAIL);
    // },
    exitModal() {
      this.$bvModal.hide(MODAL_ID_REQ_INFO_DETAIL);
    },
    handelRoute() {},
    handleReqNoti(notificationId, id) {
      this.id = id;
      let values = {};
      values.id = notificationId;
      apiNotificationSend(values);
      this.$bvModal.hide(MODAL_ID_REQ_INFO_DETAIL);
      if (this.authInfo.roleCode == this.authPublishing) {
        this.$bvModal.show("modalShowEditDeprament");
      } else {
        this.$bvModal.show("modalShowEdit");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../assets/scss/mixins";
@import "./../../assets/scss/variables";
@import "./../../assets/scss/general";
img {
  width: 15px;
  height: 15px;
}
.modal-noti {
  &__head {
    margin-bottom: 10px;
  }

  &__body {
    @extend .font-size-15;

    .item {
      @extend .display-flex;
      padding: 10px 0;

      &:not(:last-child) {
        border-bottom: 1px solid $color_border_line;
      }

      &__label {
        @extend .margin-0;
        margin-right: 8px;
      }

      &__val {
        @extend .primary-color-txt;
      }
    }
  }

  &__footer {
    padding: 30px 0 5px;

    > * {
    }
  }
}
</style>